import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { MovingImageService } from '../../../cms/services/moving-image/moving-image.service'
import { EventService } from '@spartacus/core'
import { VideoOpenEvent } from '../../../cms/services/moving-image/video-events'
import { ModalImageEvent } from '../../../cms/components/shared/gtm-event/image-events'
import { filter, take, tap } from 'rxjs/operators'
import { GalleryImageData } from '../../../models'
import { MiVideo } from '../../../cms/services/moving-image/moving-image'
import { UcService } from '../../../cms/enums/uc-service'
import { Subscription } from 'rxjs'
import { MbConstants } from '../../mb-constants'
import { GotVideoByIdEvent } from '../../../cms/components/shared/events/got-video-by-id-event'

export interface PdpGalleryDialog {
  position?: string;
  activeImage?: GalleryImageData;
  previousActiveImage?: GalleryImageData;
  gallery?: GalleryImageData[];
  hasApplicationData?: boolean;
  productName?: string;
  videoThumbnails?: GalleryImageData[];

  [k: string]: any;
}

@Component({
  selector: 'mb-pdp-gallery-dialog',
  templateUrl: './pdp-gallery-dialog.component.html',
  styleUrls: ['./pdp-gallery-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PdpGalleryDialogComponent implements PdpGalleryDialog, OnInit, OnDestroy {

  isSingleImage = false
  containerId = 'mbPdpPlayerContainerID'
  activeImageIndex = 0
  previousActiveImage: GalleryImageData | undefined
  subscription = new Subscription()
  constants = MbConstants

  @Input() position = 'PDP' //from where the event originates
  @Input() activeImage: GalleryImageData | undefined
  @Input() gallery: GalleryImageData[] | undefined
  @Input() hasApplicationData: boolean | undefined
  @Input() productName: string | undefined
  @Input() videoThumbnails: GalleryImageData[] | undefined

  readonly ucService = UcService

  constructor (public modal: NgbActiveModal,
               protected miService: MovingImageService,
               protected events: EventService) {
  }

  ngOnInit () {
    this.events.dispatch(new ModalImageEvent('Visuals', `Position_${this.position}`, true))
    this.isSingleImage = (!!this.activeImage?.videoId && !this.gallery) || this.gallery?.length === 1
    this.openVideo(this.activeImage?.videoId)
    this.activeImageIndex = this.activeImage?.videoId
      && this.gallery?.findIndex(video => video?.videoId === this.activeImage?.videoId)
      || this.gallery?.findIndex(image => image?.image === this.activeImage?.image)
      || 0
  }

  ngOnDestroy () {
    this.events.dispatch(new ModalImageEvent('Visuals', `Position_${this.position}`, false))
    this.subscription?.unsubscribe()
  }

  onGalleryClickedHandler (imageData: GalleryImageData): void {
    this.previousActiveImage = this.activeImage
    this.activeImage = imageData
    this.openVideo(imageData.videoId)
    if (this.previousActiveImage?.videoId) {
      this.miService.removeBlockedContentReplacerFromDOM(this.previousActiveImage.videoId, 'use-to-remove-blocker-for-modal')
    }
  }

  protected openVideo (videoId?: string) {
    this.subscription = this.miService.getVideoById(videoId).pipe(
      take(1),
      filter(video => Boolean(video)),
      tap(video => {
        this.events.dispatch(new GotVideoByIdEvent(video))
        this.videoThumbnails?.map(thumbnail =>
          thumbnail?.videoId === video?.id ? thumbnail.image = video?.stills?.find((still) => still.quality === this.constants.THUMBNAIL_FORMAT)?.url ?? '' : undefined)
      }),
      tap(video => this.events.dispatch(new VideoOpenEvent((video as MiVideo).title))),
      tap(video => this.miService.createPlayerForVideo(this.containerId, video))
    ).subscribe()
    return videoId && this.subscription
  }
}
